<script>
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import ActiveTable from "../../../components/ActiveTable/ActiveTable.svelte";
	import { Col, Row } from "sveltestrap";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import {
		activeTableHasError,
		errorMessage,
		loading,
		toastMessage,
	} from "src/store/store";
	import client from "src/services/client";
	import { arrayToQueryParams, extractErrorMessage } from "src/utils/misc";
	import { navigate } from "svelte-routing";
	import ConfirmModal from "../../../components/CustomModal/ConfirmModal.svelte";
	import queryString from "query-string";
	import { onDestroy } from "svelte";

	let columnData = {
		vehicleNo: undefined,
		Task: undefined,
		Priority: undefined,
		Remarks: undefined,
	};

	let tableData = new Array(20).fill(null).map(() => ({ ...columnData }));

	let hasError;

	let openConfirm = "";

	let checkTableContent = false;

	const modalCopy = {
		backlog: {
			header: "Add to backlog",
			bodyText:
				"Do you want to add the following tasks into the backlog?",
		},
		assign: {
			header: "Assign tasks to users",
			bodyText:
				"You are about to assign these task to user(s). After assigning, these tasks will be added into the “Active” tab. Are you sure you want to proceed?",
		},
	};

	function resolveError() {
		hasError = false;
	}

	function updateTableData(updatedData) {
		tableData = updatedData;
	}

	async function handleSubmit() {
		let data = filterCompleteRows(tableData);
		try {
			loading.set(true);
			const res = await client("/v1/Tasks", {
				method: "POST",
				version: "Tasking",
				data: { tasks: formatTableToData(data) },
			});
			if (res.status === 201) {
				loading.set(false);

				if (openConfirm === "assign") {
					navigateToAssign(res.data);
				} else {
					navigate("/jobs?tab=3");
				}
				openConfirm = false;
				return;
			}
		} catch (error) {
			loading.set(false);
			console.log(error);
			extractErrorMessage(error);
			return;
		}
	}

	const filterCompleteRows = (data) => {
		return data.filter((row) => {
			return row.vehicleNo && row.Task && row.Priority;
		});
	};

	function formatTableToData(data) {
		return data.map((row) => {
			return {
				vehicleId: parseInt(row.vehicleNo.value),
				presetTaskId: parseInt(row.Task.value),
				priority: parseInt(row.Priority.value),
				plannerRemarks: row.Remarks,
			};
		});
	}

	function navigateToAssign(generatedTaskIds) {
		let queryParams = queryString.stringify(
			arrayToQueryParams({
				taskIds: generatedTaskIds,
			})
		);

		navigate(`/jobs/assign?${queryParams}`);
	}

	function handleClick(menu) {
		handleTableError();
		if (hasError) {
			toastMessage.set({
				message: "Please ensure that all fields are filled up.",
				type: "danger",
			});
			return;
		}
		if (menu === "assign") {
			openConfirm = "assign";
			return;
		}
		if (menu === "backlog") {
			openConfirm = "backlog";
			return;
		}
	}

	function handleTableError() {
		let styleChanged = false;
		// Check values for rows with incomplete data
		let filteredData = tableData.map((row) => {
			if (row.vehicleNo || row.Task || row.Priority) {
				return row;
			}
			return null;
		});
		// Remove empty rows after last item containing value
		const lastIndex = filteredData.reduce((lastIndex, row, index) => {
			if (row) {
				return index;
			}
			return lastIndex;
		}, -1);
		filteredData.splice(lastIndex + 1);
		// Replace null rows with empty value columns
		filteredData = filteredData.map((row) => {
			if (row === null) {
				return columnData;
			} else {
				return row;
			}
		});

		filteredData.forEach((row, rowIndex) => {
			Object.keys(columnData).forEach((colKey, colIndex) => {
				if (colIndex !== 3) {
					const cellElement = document.getElementById(
						`input-${rowIndex}-${colIndex}`
					);
					if (cellElement && !row[colKey]) {
						cellElement.style = "border: 2px solid red !important";
						styleChanged = true;
					}
				}
			});
		});
		return activeTableHasError.set(styleChanged);
	}

	function changeCheckTable(hasError) {
		checkTableContent = false;
		hasError = hasError;
	}

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	activeTableHasError.subscribe((value) => {
		hasError = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div class="mb-3">
			<ErrorMessageHandler message={err} />
			<Row>
				<Col class="row d-flex align-items-start mx-0">
					<PageHeader title="Create Task" />
				</Col>
				<Col class="d-flex flex-row-reverse" style="height: 70px">
					<div class="mx-2">
						<CustomButton
							color="primary"
							buttonText="Assign"
							onClick={() => handleClick("assign")}
						/>
					</div>
					<div class="mx-2">
						<CustomButton
							buttonText="Add to backlog"
							onClick={() => handleClick("backlog")}
						/>
					</div>
					<div class="mx-2">
						<CustomButton
							buttonText="Cancel"
							onClick={() => navigate("/jobs?tab=3")}
						/>
					</div>
				</Col>
			</Row>
		</div>
	</Col>
	<ActiveTable
		{tableData}
		{columnData}
		{hasError}
		{resolveError}
		{updateTableData}
		{checkTableContent}
		{changeCheckTable}
	/>
</Row>
<ConfirmModal
	open={Boolean(openConfirm)}
	header={modalCopy[openConfirm]?.header}
	bodyText={modalCopy[openConfirm]?.bodyText}
	buttonText={"Confirm"}
	buttonColor={"primary"}
	toggle={() => { open = false; openConfirm = false; }}
	outline={false}
	{handleSubmit}
/>